import { EventDeclaration } from '../event-store/event-declarations.js';

export function defineEvents<T extends EventDeclaration<any>[]>(
  val: T,
): { [Prop in T[number] as Prop['key']]: Prop } {
  return val.reduce<any>((map, evt) => {
    map[evt.key] = evt;
    return map;
  }, {});
}
